/**
 * Grand Quack Auto — building AABB collision utility.
 *
 * Simple 2D (XZ plane) point-vs-AABB push-out for entities without physics
 * bodies (ducklings) and as a safety net for the duck.
 */

import { buildingDefs } from '../world/cityGenerator';

const PAD = 0.3; // padding so entities don't graze walls

/**
 * If (x, z) is inside any building AABB, push it to the nearest edge.
 * Returns the corrected position. If not inside any building, returns as-is.
 */
export function pushOutOfBuildings(x: number, z: number): { x: number; z: number } {
  for (const b of buildingDefs) {
    const halfW = b.w / 2 + PAD;
    const halfD = b.d / 2 + PAD;
    const dx = x - b.x;
    const dz = z - b.z;

    if (Math.abs(dx) < halfW && Math.abs(dz) < halfD) {
      // Inside this building — push to nearest edge.
      const pushRight = halfW - dx;
      const pushLeft = halfW + dx;
      const pushFar = halfD - dz;
      const pushNear = halfD + dz;
      const minPush = Math.min(pushRight, pushLeft, pushFar, pushNear);

      if (minPush === pushRight) return { x: b.x + halfW, z };
      if (minPush === pushLeft) return { x: b.x - halfW, z };
      if (minPush === pushFar) return { x, z: b.z + halfD };
      return { x, z: b.z - halfD };
    }
  }
  return { x, z };
}
